export const LAMBDA_DEFAULT_PAGE_SIZE = 50;
export const LAMBDA_HOT_RELOAD_BUCKET_NAME = 'hot-reload';
